import { User } from "../../model/root/User";
const apiUrl = process.env.REACT_APP_API_URL;

export const PostUsuarisDuplicar = async (page: string, user : User) => {
    try{
        const response = await fetch(`${apiUrl}:8071/usuaris/duplicar`,{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(user)
        });

        if (response.ok){
            const jsonData = await response.json();
            return jsonData;
        }else {
            alert(await response.text());
        }
    } catch(error){
        console.log('Error al obter los datos', error);
    }
};